import type { Extension } from '@codemirror/state';

import {
  usedPinnedFilters,
  usedRecentFilters,
} from '../editor-state-configs/editor-config.js';

export const FilterFieldRecentSavedFiltersExtension: Extension = (() => [
  usedRecentFilters,
  usedPinnedFilters,
])();
